<template>
  <v-container fluid class="pa-0 ma-3">
    <v-btn
      class="ma-2"
      @click="exportToExcel"
      append-icon="mdi-file-excel"
      variant="outlined"
      >Excel</v-btn
    >
    <v-btn
      class="ma-2"
      @click="print"
      append-icon="mdi-printer"
      variant="outlined"
      >print</v-btn
    >

    <v-container>
      <v-form>
        <v-date-input
          variant="outlined"
          rounded
          label="من"
          v-model="date1"
        ></v-date-input>
        <v-date-input
          variant="outlined"
          rounded
          label="إلى"
          v-model="date2"
        ></v-date-input>
      </v-form>
    </v-container>
    <v-container>
      <v-div id="printArea" dir="rtl">
        <v-data-table
          v-model="selected"
          :items="metersAmounts"
          :headers="headers"
        >
          <template v-slot:[`item.amount`]="{ item }">
            <v-container>
              <p>{{ item.last_reading - item.last_paid }}</p>
            </v-container>
          </template></v-data-table
        >
      </v-div>
    </v-container>
  </v-container>
  <overlay-loader v-model="loading" />
</template>

<script>
import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";
import { VDateInput } from "vuetify/labs/VDateInput";

import * as XLSX from "xlsx";

export default {
  components: {
    VDateInput,
    OverlayLoader,
  },
  data: () => ({
    date1: null,
    date2: null,
    headers: [
      { title: "اسم العداد", key: "name" },
      { title: "رقم العداد", key: "code" },
      { title: "مجموغ الاستهلاك", key: "totalAmount" },
      { title: "استهلاك الأبناء", key: "childrenAmounts" },
    ],
    loading: false,
    dialog: false,
  }),
  computed: {
    actions() {
      return repo.actions.getAllActions();
    },
    meters() {
      return repo.meters.getAllMeters();
    },
    metersActions() {
      let uu = this.actions;

      if (this.date1 != null) {
        const filterDate = new Date(this.date1);

        uu = uu.filter((x) => new Date(x.actionDate) >= filterDate);
      }

      if (this.date2 != null) {
        const filterDate = new Date(this.date2);
        uu = uu.filter((x) => new Date(x.actionDate) <= filterDate);
      }
      console.log("uu", uu);
      return uu;
    },
    metersAmounts() {
      let x = [];
      this.meters.forEach((element) => {
        x.push({
          name: element.name,
          code: element.code,
          totalAmount: this.meterAmount(element.id),
          childrenAmounts: this.totlaChildrenAmounts(element.id),
        });
      });
      return x;
    },

    filteredMeters() {
      return this.meters;
    },
    dataToExport() {
      const res = this.metersAmounts.map(
        ({ name, code, totalAmount, childrenAmounts }) => ({
          name: name,
          code: code,
          totalAmount: totalAmount,
          childrenAmounts: childrenAmounts,
        })
      );
      return res;
    },
  },
  methods: {
    totlaChildrenAmounts(meterId) {
      // Helper function to find children recursively
      function findChildren(meterId, meters) {
        let children = [];

        for (let meter of meters) {
          if (meter.parent_id === meterId) {
            children.push(meter);
            children = children.concat(findChildren(meter.id, meters)); // Recursively find children's children
          }
        }

        return children;
      }

      // Step 1: Find the meter by meterId
      const meter = this.meters.find((m) => m.id === meterId);

      // Step 2: If the meter is found, get its children
      if (!meter) return 0; // Return 0 if the meter doesn't exist

      const childMeters = findChildren(meterId, this.meters);

      // Step 3: Collect actions from child meters
      const childActions = this.metersActions.filter((action) =>
        childMeters.some((child) => child.id === action.meter_id)
      );

      // Step 4: Calculate the total of values
      const totalValue = childActions.reduce(
        (total, action) => total + action.value,
        0
      );

      return totalValue;
    },
    meterAmount(meter_id) {
      const filteredActions = this.metersActions.filter(
        (action) => action.meter_id === meter_id
      );
      const totalAmount = filteredActions.reduce(
        (total, action) => total + action.value,
        0
      );
      return totalAmount;
    },
    exportToExcel() {
      // Create a worksheet from the data
      const worksheet = XLSX.utils.json_to_sheet(this.dataToExport);

      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Export the workbook to a file
      XLSX.writeFile(workbook, "data.xlsx");
    },
    print() {
      const printElement = document.getElementById("printArea");
      if (!printElement) {
        console.error("Element not found");
        return;
      }

      const printContent = printElement.innerHTML;
      const printWindow = window.open("", "_blank", "width=800,height=600");

      printWindow.document.write(`
    <html>
        <head>
            <title>Print Content</title>
            <style>
                @media print {
                    body {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0;
                        height: 100vh;  /* Ensure the body takes full height */
                        padding: 20px;
                        box-sizing: border-box; /* Include padding in width calculations */
                    }
                    @page {
                        margin: 0;
                    }
                }
            </style>
        </head>
        <body dir=rtl>
            ${printContent}
        </body>
    </html>
`);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    },

    async fetch() {
      this.loading = true;
      const res = await repo.actions.fetchAll();
      const res2 = await repo.meters.fetchAll();
      if (res && res2) {
        //swalFun.success("success");
        console.log(res2);
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
